import mobx, { observable, action, computed, autorun } from 'mobx';
// import _ from 'lodash';
import api from '../api';

export class financeStore {
	@observable payout = null;
	@observable deposit = null;

	@action init(type) {
		if (type == 'payout') {
			this.payout = new payout(this);
		} else if (type == 'deposit') {
			this.deposit = new deposit(this);
		}
	}

	@action clear(type) {
		if (type) {
			this[type] = null;
		} else {
			this.payout = null;
			this.deposit = null;
		}
	}
}

export default new financeStore();
	
class payout {
	@observable store = true;
	@observable isLoading = true;
	@observable data = null;
	@observable amount = '';
	@observable noty = 0;
	@observable editStatus = false;
	@observable wait = false;
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

	constructor(store) {
		this.store = store;
		this.getData();
	}

	@action setResult(text, type = 0) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type;
	}

	@action clear() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	@action inputAmount(val) {
		console.log(val.replace(/[^\,\d]+/g,""));
		const number = val.replace(/[^\.\d]+/g,"").replace( /^([^\.]*\.)|\./g, '$1');
    this.clear();
		if (number.toString().length > 0){
  		this.amount = number;
    } else {
      this.amount = '';
    }
	}

	@action getData() {
		return api.finance.getPayout().then(
				action(
					res => {
						if (typeof res.result !== 'undefined') {
							if (res.result == 4) {
								this.noty = 1;
							} else {
								this.data = res.result;
							}
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.isLoading = false; }));
	}

	@action create() {
		this.wait = true;
		this.clear();
		return api.finance.createPayout({amount: this.amount}).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.editStatus = false;
								if (res.result == 4) {
									this.noty = 1;
									this.data = '';
								} else {
									this.data = res.result;
									this.setResult(res.text, 1);
								}
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.wait = false; }));
	}

	@action cancel() {
		this.clear();
		return api.finance.cancelPayout({payment_id: this.data.id}).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.setResult(res.text, 1);
							this.amount = '';
							this.editStatus = false;
							this.data = '';
						}else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
	}

	@action edit() {
		return api.finance.checkPayout().then(
			action(
				res => {
					if (res.code == 'OK') {
						this.editStatus = true;
						this.amount = this.data.amount;
					}else {
						this.setResult('CANCEL_PAYMENT_ERROR_1');
						this.amount = '';
						this.editStatus = false;
						this.data = '';
					}
				}
			)
		)
		.catch(action(err => {
      this.setResult('SERVER_TEMPORARILY_DOWN');
    }))
		
	}
}

class deposit {

}


// WEBPACK FOOTER //
// ./src/stores/financeStore.js